import PropTypes from "prop-types";

import { chartNames, strCode } from "../../../../consts";
import { rumEventsUtil } from "../../../../utils";

import { DashboardBarChart } from "../../../../components";
import { DashboardTemplate } from "../../../../templates";

const SettingUsageChart = ({
  settings,
  getChartFilter = () => {},
  getIsLoading = () => {},
  getIsError = () => {}
}) => {
  return (
    <DashboardTemplate
      id={chartNames.SETTING_USAGE}
      title={strCode.SETTING_USAGE_TITLE}
      isLoading={getIsLoading(chartNames.SETTING_USAGE)}>
      <DashboardBarChart
        data={settings?.statistics}
        isLoading={getIsLoading(chartNames.SETTING_USAGE)}
        isError={getIsError(chartNames.SETTING_USAGE)}
        yAxisLabel={strCode.COUNT_LABEL}
        metricsConfig={rumEventsUtil.getMetricsConfig({
          chartName: chartNames.SETTING_USAGE,
          deviceType: getChartFilter(chartNames.SETTING_USAGE)
        })}
        isCustomTicks
      />
    </DashboardTemplate>
  );
};

SettingUsageChart.propTypes = {
  settings: PropTypes.shape({
    statistics: PropTypes.arrayOf(
      PropTypes.shape({
        setting: PropTypes.string.isRequired,
        metrics: PropTypes.objectOf(PropTypes.number).isRequired
      })
    )
  }).isRequired,
  getChartFilter: PropTypes.func.isRequired,
  getIsLoading: PropTypes.func.isRequired,
  getIsError: PropTypes.func.isRequired
};

export default SettingUsageChart;
